import { render, staticRenderFns } from "./PinnedBtn.vue?vue&type=template&id=1b5481c2&scoped=true"
import script from "./PinnedBtn.vue?vue&type=script&lang=js"
export * from "./PinnedBtn.vue?vue&type=script&lang=js"
import style0 from "./PinnedBtn.vue?vue&type=style&index=0&id=1b5481c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5481c2",
  null
  
)

export default component.exports